import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { SHORTCUT_HELP } from "@/hooks/useKeyboardShortcuts";

/**
 * Radix Dialog wrapper (XTRA-04): role/aria-modal, focus trap, focus restore
 * to the opener and Esc-to-close all come from the primitive — same idiom as
 * alarms/TemplatesGallery. Content is nested inside Overlay (the documented
 * Radix pattern) so the original flex-centering classes carry over unchanged.
 */
export function ShortcutHelpDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Dialog.Root open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[80] flex items-center justify-center bg-bg/70 px-4 backdrop-blur-sm">
          <Dialog.Content
            aria-describedby={undefined}
            className="w-full max-w-md overflow-hidden rounded-xl border border-edge bg-surface shadow-2xl"
          >
            <div className="flex items-center justify-between border-b border-edge px-4 py-3">
              <Dialog.Title className="text-sm font-semibold">Keyboard shortcuts</Dialog.Title>
              <Dialog.Close asChild>
                <button className="rounded p-1 text-text-faint transition hover:text-text" aria-label="Close">
                  <X size={14} />
                </button>
              </Dialog.Close>
            </div>
            <ul className="divide-y divide-edge">
              {SHORTCUT_HELP.map((s) => (
                <li key={s.keys} className="flex items-center justify-between px-4 py-2 text-xs">
                  <span className="text-text-muted">{s.label}</span>
                  <kbd className="rounded border border-edge bg-surface-2 px-2 py-0.5 font-mono text-[11px] text-text">{s.keys}</kbd>
                </li>
              ))}
            </ul>
            <div className="border-t border-edge bg-surface-2 px-4 py-2 text-[10px] text-text-muted">
              Tip: vim-style two-key shortcuts. Press <kbd className="rounded border border-edge px-1 font-mono">g</kbd> then a letter within 1 s.
            </div>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
